import { Typography } from "@mui/material";
import { ReactElement } from "react";
import { StyledTableCell } from "./styles";
import { Link } from "react-router-dom";
import theme from "../../../../theme";

type Props = {
  valueMaxLines?: number;
  isFirst: boolean;
  columnWidth?: string;
  stripedTable?: boolean;
  disabled?: boolean;
  value: string | ReactElement;
  linkTo?: string;
};

const FormTableCell = ({
  valueMaxLines,
  columnWidth,
  isFirst,
  disabled,
  value,
  linkTo,
}: Props) => {
  const truncateCss = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: valueMaxLines || "unset",
    WebkitBoxOrient: "vertical",
  };

  return (
    <StyledTableCell
      columnWidth={columnWidth}
      isFirst={isFirst}
      disabled={disabled}
    >
      <Typography
        variant={disabled ? "disabled" : "body1"}
        sx={{ ...truncateCss }}
      >
        {linkTo ? (
          <Link
            style={{
              textDecoration: "none",
              color: theme.palette.primary.main,
            }}
            to={linkTo}
            target="_blank"
            rel="noopener noreferrer"
          >
            {value}
          </Link>
        ) : (
          <>{value}</>
        )}
      </Typography>
    </StyledTableCell>
  );
};

export default FormTableCell;
